// Copyright (c) 2020 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getTabmSettings} from '../../shared/repositories';
import {readSpaClaims} from './get-spa-claims';

export const readTabmSettings = (selectedDealers, userId) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const tcsmSettingsArray = await getTabmSettings(userId);

            const tcsmSettings = tcsmSettingsArray[0];

            dispatch({
                tcsmSettings,
                type: actions.UPDATE_TABM_WIP_TABM_SETTINGS
            });

            dispatch({
                selectedSpaLevels: tcsmSettings.selectedSpaLevels,
                type: actions.UPDATE_TABM_WIP_SELECTED_SPA_LEVELS
            });

            readSpaClaims(selectedDealers, tcsmSettings.selectedSpaLevels)(dispatch);

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const resetTcsmSettingsFacet = selectedSpaLevels => ({
    selectedSpaLevels,
    type: actions.RESET_TABM_WIP_TABM_SETTINGS_FACET
});

export const toggleSpaLevelsListItems = allowedSpaLevels => ({
    allowedSpaLevels,
    type: actions.TOGGLE_TABM_WIP_SPA_LEVELS_LIST
});

export const updateSelectedSpaLevelsList = (item, isSelected) => ({
    isSelected,
    item,
    type: actions.UPDATE_TABM_WIP_SELECTED_SPA_LEVELS_LIST
});



// WEBPACK FOOTER //
// ./src/tabm/wip/action-creators/tcsm-settings.js